import { InferType, object, string } from 'yup'

export const changeParticipantCohortSchemaValidation = object({
  cohort: string().required(),
}).required()

export type ChangeParticipantCohortSchemaValidationType = InferType<typeof changeParticipantCohortSchemaValidation>
